
const appStateConfig = {
  sessionStorageKey: "lumnistudents:sessionState",
  tokenStorageKey: "lumnistudents:auth:token",
  personStorageKey: "lumnistudents:personState",
};

export default appStateConfig;
